import { useEffect, useState, useRef } from "react";
import PostFormDataByAgg from "../../utils/axios";
import ModalAlert from "../../components/ModalAlert";
import LottieLoading from "../../components/child/LottieLoading";


const UploadReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(<div></div>);
  const [file, setFile] = useState(null);

  const fileInputRef = useRef();


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("file", file);

    PostFormDataByAgg({
      url: "looker/v1/report/upload-file",
      body: formData,
      onResponse: handleFileUploadSuccess,
      onError: handleFileUploadError,
    });
  };

  const handleFileUploadSuccess = (response) => {
    setIsLoading(false);
    if (response.data.code === "2002000") {
      const TotalInserted = response?.data?.data?.totalInserted??'0'
      const reportDate = response?.data?.data?.fileDate??'[report_date]'
      const message = `File uploaded per ${reportDate} successfully!. ${TotalInserted} rows added`
      setModalOpen(
        <ModalAlert
          show={true}
          type={"success"}
          text={message}
          action={() => {
           
            setFile(null);

            if (fileInputRef.current) {
              fileInputRef.current.value = ""; // Clear the file input
            }
          }}
        />,
      );
    } else {
      setModalOpen(
        <ModalAlert
          show={true}
          type={"failed"}
          text={response.data.message || "File upload failed!"}
          action={() => {}}
        />,
      );
    }
  };

  const handleFileUploadError = (error) => {
    setIsLoading(false);
    setModalOpen(
      <ModalAlert
        show={true}
        type={"failed"}
        text="Error uploading file!"
        action={() => {
          setFile(null);

          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Clear the file input
          }
        }}
      />,
    );
  };

  useEffect(() => {

  }, []);


  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-lg">
            <div
              className="card-header text-center"
              style={{
                background: "rgba(192, 219, 255, 0.45)",
                backdropFilter: "blur(90px)",
                color: "White",
                padding: "20px",
                borderRadius: "12px",
              }}
            >
              <h4>UPLOAD LOOKER FILE</h4>
            </div>
            <div className="card-body">
              <p className="text-center">
                Select a file to upload. *Format file csv*.
              </p>
              <form onSubmit={handleSubmit}>

                {/* File Upload */}
                <div className="mb-3">
                  <label className="form-label">Choose File</label>
                  <input
                    required
                    type="file"
                    className="form-control"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                </div>

                {/* Upload Button */}
                <div className="text-center">
                  <button
                    className="btn btn-primary cursor-pointer"
                    type="submit"
                  >
                    <i className="ri-upload-cloud-line me-4"></i>
                    Upload
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {isLoading && <LottieLoading text="Loading..." />}
        {modalOpen}
      </div>
    </div>
  );
};

export default UploadReport;
